import type { UseQueryResult } from "@tanstack/react-query";

import {
  type GetBillingAccountOverviewResponse,
  SubscriptionStatusEnum,
} from "@nlc/shared-types";
import { useQuery } from "@tanstack/react-query";

import { subscriptionKeys } from "@/hooks/queryKeys";

export function useBillingAccountOverview(
  projectId: number,
): UseQueryResult<GetBillingAccountOverviewResponse> {
  return useQuery<GetBillingAccountOverviewResponse>({
    queryFn: () => buildMockAccountOverview(projectId),
    queryKey: subscriptionKeys.accountOverview(projectId),
    staleTime: Infinity,
  });
}

function buildMockAccountOverview(
  projectId: number,
): GetBillingAccountOverviewResponse {
  return {
    account: {
      cancelledAt: null,
      createdAt: "2026-01-01T00:00:00.000Z",
      id: projectId,
      name: "Secret Agent",
      responsible: { name: "Alana G" },
    },
    addOns: [],
    coupons: [{ code: "GS_20_ONCE", id: "gs_20_once" }],
    creditBalance: { amount: "1480.65", currency: "USD" },
    plan: {
      designSlotCount: 5,
      productName: "Marketing",
      supportTier: "fully-managed",
    },
    subscriptionStatus: SubscriptionStatusEnum.ACTIVE,
    upcomingPayment: {
      amount: "3240",
      currency: "USD",
      discount: { label: "20% off" },
      renewalDate: "2026-11-20T00:00:00.000Z",
    },
  };
}
